import webApiClientSingleton from '../webApiClientSingleton';
import { categories } from '../player/constants/logging';

export default function logCategoryActionLabel(event, moreParams) {
  const params = {
    c: 'eventlist',
    ...moreParams, // can optionally add an id param
  };

  if (!event.category) {
    event.category = categories.ad;
  }

  webApiClientSingleton.instance.logging.eventLog({ event, params });
}
